import React,{useState,useEffect} from 'react'
import { Box, IconButton, Table, TableBody, Tooltip,
    TableContainer, TableHead, TableRow, Typography,    
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment';
import {celda} from '../Generales/TablaGeneral';
import { printConsole } from '../funciones/ConsolaLog';
import NuevoContrato from './NvoEditSeguro';
import {AddCircleOutline} from '@material-ui/icons';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
//import ArrowCircleDownIcon from '@material-ui/icons/ArrowCircleDown';
import ModalArchivo from './ModalArchivo';
const useStyles = makeStyles((theme) => ({
    
        root: {
            width: '100%',
        },
        container: {
            maxHeight: 420,
            width: '100%',
        },
        tableRow: {
            "&$selected, &$selected:hover": {
                backgroundColor: "#F46239"
            }
        },
        tableCell: {
            "$selected &": {
                color: "white"
            }
        },
        hover: {},
        selected: {}
    
  }));

const TablaArchivos = ({datos,contrato,llenarListFile}) => {
    const classes = useStyles();
    const [selectedID, setSelectedID] = useState(null);
    const [modalNvoContrato,setModalNvoContrato]= useState(false);
/*     useEffect(() => {
        printConsole(datos)
    
    
    }, [ ]) */
 
    function Row(props) {
        const {row} = props;       
        let nomLink=row.Archivo.length!==0 ? row.Archivo.substring(row.Archivo.lastIndexOf('/')+1,row.Archivo.length):"" 
        let modespacio=(row.Tamanio/1000000).toString()
        let espacio=modespacio.length!==0 ? modespacio.substring(0,modespacio.lastIndexOf('.')+3):"" 
        return (           
        <TableRow
            onClick={() => { setSelectedID(row) }}
            selected={selectedID?.Id === row.Id} className={classes.tableRow}
            classes={{hover: classes.hover, selected: classes.selected}}
        >
             {celda("center", {width: 45+'px'}, 
                row.Archivo.length !== 0 ?
                <Tooltip title={`Descargar ${nomLink}`}>
                <a href={`javascript:window.open('${row.Dir}${row.Archivo}');`}> ​​​​​​
                    <IconButton size="small"  >
                        <img src={`${row.Icon}`} style={{width:"22px", height:"22px"}} />
                        {/* <PictureAsPdfIcon/> */}
                    </IconButton>
                </a>
                </Tooltip>
                :null
            , 1, classes.tableCell)}   
            {celda("left", {fontSize:12+'px'}, `${nomLink} `, 2, classes.tableCell)}      
            {celda("left", {fontSize:12+'px', paddingLeft:".2rem"}, `${row.TpNom} `, 2, classes.tableCell)}      
            {celda("left", {width: 45+'px',fontSize:12+'px', paddingLeft:".2rem"}, 
                row.FReg=== "1900-01-01 00:00" ? 
                "" : moment.utc( row.FReg).format('DD/MM/YYYY')
            , 3, classes.tableCell)}  
            {celda("right", {paddingLeft:".2rem"}, `${espacio} mb`, 4, classes.tableCell)}                                            
            {celda("left", {paddingLeft:".3rem", fontSize:12+'px'}, row.Descr, 5, classes.tableCell)}            
        </TableRow>                          
        );
    }

const tablaCompleta = () => {

    return (
    <TableContainer className={classes.container}>
    <Table stickyHeader aria-label="sticky table">
        <TableHead>
            <TableRow>
                {celda("center", {},  
                    <Tooltip title={`Agregar Archivo a la Poliza ${contrato.Poliza}`} >
                        <IconButton onClick={()=>{setModalNvoContrato(true)}} size="small" >
                            <AddCircleOutline />
                        </IconButton>
                    </Tooltip>
                , 1, "")}                 
                {celda("center", {}, "Nombre",2, "")}  
                {celda("center", {}, "Tipo",6, "")}  
                {celda("center", {}, "Envio",3, "")}                        
                {celda("center", {}, "Tamaño",4, "")}                    
                {celda("center", {}, "Descripción", 5, "")}                                                                                               
            </TableRow>
        </TableHead>
        <TableBody>                                                                 
        {datos.length !== 0 && datos[0].Id !== -1 && datos[0].Id !== "-1"? 
            (datos.map((row) => (
                <Row key={row.Id} row={row}/>
            ))) 
        : 
        <TableRow className={classes.tableRow} >            
            {celda("center", {}, "", 1, classes.tableCell)}               
            {celda("center", {}, "Sin", 2, classes.tableCell)}
            {celda("center", {}, "", 3, classes.tableCell)}
            {celda("center", {}, "Registros", 4, classes.tableCell)}
            {celda("center", {}, "", 5, classes.tableCell)}
        </TableRow>       
        }
        </TableBody>
    </Table>
    </TableContainer>
    )
    }

    const modNvoContrato= modalNvoContrato ? <ModalArchivo modalAbierto={modalNvoContrato} llenarListFile={llenarListFile}
                                                setModalAbierto={setModalNvoContrato} registro={contrato} /> :null
  return (
    <Box>
        {modNvoContrato}
        <div><Typography color="primary" style={{fontSize:18,fontWeight:500}}>{`Archivos de la Poliza ${contrato.Poliza}`}</Typography></div>
        {tablaCompleta()}
   </Box>
  )
}

export default TablaArchivos